import {
  useState
} from "react"
import ReCAPTCHA from "react-google-recaptcha"
import {  useNavigate, Link } from "react-router-dom"
import { Container, FullRow, PrimaryRowButton, RowInput, Title } from "../../components"
import { hashPassword, RECAPTCHA_SITE_KEY, sha256 } from "../../config"
import { register } from "../../endpoints"
import { App } from "antd"
import { useTheme } from "styled-components"
import { Row, Col } from "antd";
import plasmidOverlay from "../../images/plasmidOverlay.png";

//https://developers.google.com/recaptcha/docs/faq#id-like-to-run-automated-tests-with-recaptcha.-what-should-i-do


export function Register({
  redirect_link,
}: {
  redirect_link?: string
}): JSX.Element {

  const [captchaToken, setCaptchaToken] = useState<string | null>(null)

  const handleCaptchaChange = (token: string | null) => {
    setCaptchaToken(token) // Store the token for backend verification
  }
  const{modal}=App.useApp()
  
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [password2, setPassword2] = useState("")
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [institution, setInstitution] = useState("")
  const theme = useTheme()
  const [captchaError, setCaptchaError] = useState<string | null>(null)
  const [errors, setErrors] = useState<{ [key: string]: string }>({})

  function isValidEmail(email: string) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  const navigate = useNavigate()

  const handleSubmit = async () => {

    const newErrors: { [key: string]: string } = {}
    if (!email) newErrors.email = "Please fill out an email."
    else if (!isValidEmail(email)) newErrors.email = "Please enter a valid email address."

    if (!password) newErrors.password = "Please fill out a password."
    if (!password2) newErrors.password2 = "Please fill out the password confirmation."
    if (password && password2 && password !== password2)
      newErrors.password2 = "The passwords do not match, please retype."

    if (!firstName) newErrors.firstName = "Please fill out a first name."
    if (!lastName) newErrors.lastName = "Please fill out a last name."
    if (!institution) newErrors.institution = "Please fill out a lab or company name."
    if (!captchaToken) setCaptchaError("Please complete the reCAPTCHA.")

    setErrors(newErrors)

    if (Object.keys(newErrors).length > 0 || !captchaToken) return


    // if (!captchaToken) {
    //   modal.warning({ title: "warning", content: "Please complete the reCAPTCHA" })
    //   return
    // }

    // if (password !== password2) {
    //   modal.warning({
    //     title: "warning",
    //     content: "The passwords do not match, please retype",
    //   })
    //   return
    // }

    // if (!password) {
    //   modal.warning({ title: "warning", content: "Password cannot be empty" })
    //   return
    // }
    // if (!email) {
    //   modal.warning({ title: "warning", content: "Email cannot be empty" })
    //   return
    // }

    if (email.length > 0 && password.length > 0) {
      // const hash = CryptoJS.SHA256(password).toString()
      const hash=await hashPassword(await sha256( password+'plab'))
      console.log('register hash',hash)      

      const res = await register({
        email,
        password: hash,
        firstName,
        lastName,
        institution,
        captcha: captchaToken,
      })
      // consolelog('res',res)
      if (res.code === 1000) {
        // refreshUser?.({ user: res.user ?? "Login" });
        navigate("/registration-success", { 
          state: { 
            email: email,
            name: firstName 
          } 
        })

      } else {
        modal.warning({ content: res.message })
      }
    }
    
  }

  const errorStyle = { border: "1px solid red" }

  return (

      <Row style={{ minHeight: "80vh" }}>
    <Col xs={24} md={12} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
      <Container style={{ marginTop: "3.5em", minWidth: 320, maxWidth: 420, width: "100%" }}>
    <Container style={{ marginTop: "3.5em" }}>
      <FullRow>
        <Title>Register a New User</Title>
      </FullRow>
      <FullRow style={{margin: 0, padding: 0}}>
        <RowInput
          placeholder="Institution Email Address"
          type="email"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          name="email"
          maxLength={60}
          style={errors.email ? errorStyle : undefined}
        />
      </FullRow>
        {errors.email && (
        <FullRow style={{margin: 0, padding: 0}}>
          <span style={{ color: "red", fontSize: "1em", margin: 0, padding: 0 }}>{errors.email}</span>
        </FullRow>
      )}
      <FullRow style={{margin: 0, padding: 0}}>
        <RowInput
          placeholder="Password"
          type="password"
          id="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          name="password"
          maxLength={40}
          style={errors.password ? errorStyle : undefined}
        />
      </FullRow>
      {errors.password && (
        <FullRow style={{margin: 0, padding: 0}}>
          <span style={{ color: "red", fontSize: "1em" }}>{errors.password}</span>
        </FullRow>
      )}
      <FullRow style={{margin: 0, padding: 0}}>
        <RowInput
          placeholder="Retype Password"
          type="password"
          id="password2"
          value={password2}
          onChange={(e) => setPassword2(e.target.value)}
          name="password2"
          maxLength={40}
          style={errors.password2 ? errorStyle : undefined}
        />
      </FullRow>
      {errors.password2 && (
        <FullRow style={{margin: 0, padding: 0}}>
          <span style={{ color: "red", fontSize: "1em" }}>{errors.password2}</span>
        </FullRow>
      )}
      <FullRow style={{margin: 0, padding: 0}}>
        <RowInput
          placeholder="First Name"
          type="text"
          id="firstName"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          name="firstName"
          maxLength={60}
          style={errors.firstName ? errorStyle : undefined}
        />
      </FullRow>
      {errors.firstName && (
        <FullRow style={{margin: 0, padding: 0}}>
          <span style={{ color: "red", fontSize: "1em" }}>{errors.firstName}</span>
        </FullRow>
      )}
      <FullRow style={{margin: 0, padding: 0}}>
        <RowInput
          placeholder="Last Name"
          type="text"
          id="lastName"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          name="firstName"
          maxLength={60}
          style={errors.lastName ? errorStyle : undefined}
        />
      </FullRow>
      {errors.lastName && (
        <FullRow style={{margin: 0, padding: 0}}>
          <span style={{ color: "red", fontSize: "1em" }}>{errors.lastName}</span>
        </FullRow>
      )}
      <FullRow style={{margin: 0, padding: 0}}>
        <RowInput
          placeholder="Lab or Company Name"
          type="text"
          id="company"
          value={institution}
          onChange={(e) => setInstitution(e.target.value)}
          name="company"
          maxLength={40}
          style={errors.institution ? errorStyle : undefined}
        />
      </FullRow>
      {errors.institution && (
        <FullRow >
          <span style={{ color: "red", fontSize: "1em" }}>{errors.institution}</span>
        </FullRow>
      )}
      <FullRow style={{margin: 0, padding: 0}}>
        <ReCAPTCHA
          sitekey={RECAPTCHA_SITE_KEY}
          onChange={handleCaptchaChange}
        />
      </FullRow>
      {captchaError && (
        <FullRow style={{margin: 0, padding: 0}}>
          <span style={{ color: "red", fontSize: "1em" }}>{captchaError}</span>
        </FullRow>
      )}
      <FullRow>
        <PrimaryRowButton type="primary" onClick={handleSubmit} id="submit">
          Create Account
        </PrimaryRowButton>
          <Link to="/login" style={{ color: theme.primary }}>
            Already have an account? Login
          </Link>{" "}
      </FullRow>
    </Container>

     </Container>
     </Col>
      <Col xs={0} md={12} 
        style={{
      position: "relative",
      overflow: "hidden",
      minHeight: "80vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
          borderLeft: "1px solid #D3D3D3", // Add black border on the right side column
      }}>
      <img
        src={plasmidOverlay}
        alt="Plasmid"
        style={{
          position: "absolute",
          left: "-50%",
          top: 0,
          height: "100%",
          width: "auto",
          opacity: 0.3,
          objectFit: "cover",
          zIndex: 1,
          maxWidth: "none",
        }}
        draggable={false}
      />
      <div
        style={{
          zIndex: 3,
          color: "#fff",
          textAlign: "center",
          fontWeight: 700,
          fontSize: "2.5rem",
          textShadow: "0 2px 16px rgba(0,0,0,0.35)",
          pointerEvents: "none",
          padding: "0 2rem",
        }}
      >
        Start Sequencing Today
      </div>
    </Col>
  </Row>
  )
}
